import StyledSelectDropdown from "../StyledSelectDropdown"
import { FormField, SectionHeader } from "./CreateJobFields"

type InternalInformationSectionProps = {
    departments: any[]
    departmentsStatus: string
    hiringManagers: any[]
    hiringManagersStatus: string
    selectedDepartmentId: number | null
    selectedHiringManagerId: number | null
    isEditMode: boolean
    onDepartmentChange: (value: string) => void
    onHiringManagerChange: (value: string) => void
}

export const InternalInformationSection = ({
    departments,
    departmentsStatus,
    hiringManagers,
    hiringManagersStatus,
    selectedDepartmentId,
    selectedHiringManagerId,
    isEditMode,
    onDepartmentChange,
    onHiringManagerChange,
}: InternalInformationSectionProps) => (
    <section className="mb-10">
        <SectionHeader title="Internal information" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
            <FormField label="Department name" required>
                <StyledSelectDropdown
                    options={departments}
                    value={selectedDepartmentId || ""}
                    onChange={onDepartmentChange}
                    placeholder="Select department"
                    disabled={departmentsStatus === "loading"}
                />
            </FormField>

            <FormField label="Hiring manager" required>
                <StyledSelectDropdown
                    options={hiringManagers}
                    value={selectedHiringManagerId || ""}
                    onChange={onHiringManagerChange}
                    placeholder="Select hiring manager"
                    disabled={isEditMode ? false : (!selectedDepartmentId || hiringManagersStatus === "loading")}
                    disabledPlaceholder={
                        !selectedDepartmentId
                            ? "Select department first"
                            : hiringManagersStatus === "loading"
                                ? "Loading..."
                                : "Select hiring manager"
                    }
                    getOptionLabel={(manager) => `${manager.first_name} ${manager.middle_name || ""} ${manager.last_name}`.trim()}
                />
            </FormField>
        </div>
    </section>
)
